module.exports = new __parcel__URL__("airtable-logomark.84de76a4.svg").toString();